// Tram Interactions Animations
// 4 animations covering the most common CBR tram priority scenarios
// Key CBR rules: trams always have priority, stop for passengers crossing, give way at junctions

export interface TramAnimation {
  id: string;
  topic: string;
  sceneDescription: string;
  klingPrompt: string;
  negativePrompt: string;
  videoUrl: string | null;
  durationSeconds: number;
  viewType: 'top-down' | 'first-person' | 'third-person';
  freezeDescription: string;
  questionIds: string[];
}

export const tramAnimations: TramAnimation[] = [
  {
    id: 'ti-anim-1',
    topic: 'Tram Interactions',
    sceneDescription: 'Tram stopped at island stop in middle of road — passengers crossing — car must stop',
    klingPrompt:
      'Dashcam footage from inside a car on a Dutch city street approaching a tram stop. ' +
      'A yellow Dutch city tram is stopped at a tram island stop (halte) in the middle of the road, doors open. ' +
      'Two passengers step off the tram and walk across the road toward the pavement on the right. ' +
      'The car slows down and stops completely to let the passengers cross safely. ' +
      'Tram tracks visible in the asphalt, Dutch city street with bike lanes and brick buildings. ' +
      'Overcast daytime. Realistic, no text or overlays, 5 seconds.',
    negativePrompt:
      'No text, no captions, no cartoon, no aerial view, no night, no watermark, no car hitting pedestrian, ' +
      'no UK tram, no modern tram without Dutch markings',
    videoUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/animations/ti-anim-1.mp4',
    durationSeconds: 5,
    viewType: 'first-person',
    freezeDescription: 'Car stopped — tram doors open — passengers crossing road from tram to pavement.',
    questionIds: ['q-ti-2', 'q-ti-8', 'q-ti-14'],
  },
];
